module.exports = __webpack_public_path__ + "img/second_confirm_layer.0d6d7fba.png";